<!-- new theme implementation starts -->
<div class="subheader with-padding flgrow">
  <div class="row">
    <div class="col-sm-3">
      <div class="relative flmid">
        <div class="input-group flgrow">
          <input class="form-control" type="text" name="searchTerm" placeholder="{{ 'lblSearch' | translate }}"
            [(ngModel)]="pService.searchTerm" autocomplete="off" />
            <div class="input-group-append">
              <button type="button" class="btn btn-primary">
                <em class="fa fa-search"></em>
              </button>
            </div>
        </div>
      </div>
    </div>
    <div class="col-sm-2" *ngIf="dealerList && dealerList.length > 1;">
        <div class="relative flmid">
          <div class="flgrow ">
            <ng-container>
              <app-dealer-searchbox-dropdown [dealerList]="dealerList" 
              [selectedDealer]="selectedDealerId"
              ngDefaultControl name="dealerDropdown"
                (onSelectDealer)="onDealerSelected($event)" placeholder="Search Dealer"
                >
              </app-dealer-searchbox-dropdown>
            </ng-container>
          </div>
        </div>
      </div>
      <div class="col-lg-2 col-md-3 col-sm-6">
        <ng-select placeholder="{{ 'lblStatus' | translate }}" [(ngModel)]="selectedStatus" 
        (change)="StatusChange($event)">
            <ng-option *ngFor="let status of StatusList" [value]="status.id" >
                  {{status.value}}
            </ng-option>
        </ng-select>
    </div>
    <div class="col-auto ml-auto" *ngIf="userRoleRightsDetails.canAdd">
      <button type="button" (click)="onAdd()" aria-label="Center Align" type="reset" class="add-button btn btn-primary"
        translate>lblAddRentalCar</button>
    </div>
  </div>
</div>
<div class="container prel">
  <div class="row">
    <div class="c12">
      <div class="card mb-3">
        <div class="card-header d-flex" translate>
          lblRentalCars
        </div>
        <div class="table-responsive">
                  <table class="tablest1">
                    <thead>
                      <tr>
                        <th style="width: 55px" scope="col">#</th>
                      
                        <th style="width: 120px" scope="col" sortable="licensePlatNo" (sort)="onSort($event)" translate>lblRegNumber
                        </th>
                        <th scope="col" translate>lblColor</th>
                        <th scope="col" sortable="fuel" (sort)="onSort($event)" translate>lblFuelType</th>
                        <th scope="col" sortable="dealerName" (sort)="onSort($event)" translate>lblDealerName</th>
                        <th class="text-center" scope="col" sortable="isActive" (sort)="onSort($event)" translate>lblActive
                        </th>
                        <th style="width: 120px" scope="col" class="text-center" translate>lblAction</th>
                      </tr>
                    </thead>
                    <tbody>
                      <ng-container *ngIf="rentalCarList?.length>0; else load_else">
                        <tr *ngFor="let car of rentalCarList; let i=index">
                          <td>{{ car.rowNumber }}</td>
                        
                          <td>
                            <div class="flmid">
                              <div class="licplate LPNo d-flex">
                                <span class="icn-flag" [ngClass]="licensePlateClass"></span>
                                {{car.licensePlatNo}}
                              </div>
                              <div class="imgWid">
                                <img af-brand-logo [data-code]="car.logo" data-type="BRAND" class="{{car.logo}}-icon common" alt="brandImg"
                                  [title]="car.logo" class="brandicon" />
                              </div>
                            </div>
                            <div class="mt-1">
                              <ngb-highlight [result]="car.model" class="flmid semibold fs-12px lh-16px">
                              </ngb-highlight>
                            </div>
                          </td>
                         
                          <td>
                            <ngb-highlight [result]="car.color" ></ngb-highlight>
                          </td>
                          <td>
                            <ngb-highlight [result]="car.fuel" [term]="pService.searchTerm"></ngb-highlight>
                          </td>
                          <td>
                            <ngb-highlight [result]="car.dealerName" [term]="pService.searchTerm"></ngb-highlight>
                          </td>
                          <td class="text-center">
                            <em class="fas" [ngClass]="{'fa-check': car.isActive, 'fa-close': !car.isActive}"></em>
                          </td>
                          <td class="nowrap text-center">
                            <a class="btn btn-ico" ngbTooltip="{{'lblEdit' | translate}}" tooltipClass="custom-revert" (click)="onEdit(car)"
                              *ngIf="userRoleRightsDetails.canEdit">
                              <em class="fas fa-pencil-alt fa-lg"></em>
                            </a>
                            <span class="ico-div" *ngIf="userRoleRightsDetails.canDelete"></span>
                            <a class="btn btn-ico" ngbTooltip="{{'lblDelete' | translate}}" tooltipClass="custom-revert" (click)="deleteRentalCar(car.id)"
                              *ngIf="userRoleRightsDetails.canDelete">
                              <em class="far fa-trash-alt fa-lg"></em>
                            </a>


                          </td>
                        </tr>
                      </ng-container>
                      <ng-template #load_else>
                        <tr>
                          <td colspan="8" class="no-record" translate>lblNoRecordsFound</td>
                        </tr>
                      </ng-template>
                    </tbody>
                  </table>

        </div>
        <div class="card-footer">
<div class="d-flex justify-content-between">
  <div class="d-flex justify-content-between">
    <ngb-pagination [collectionSize]="pService.total$  | async" [(page)]="pService.page" [pageSize]="pService.pageSize"
      [maxSize]="3">
    </ngb-pagination>
    <select class="custom-select mx-2" style="width: auto" name="pageSize" [(ngModel)]="pService.pageSize">
      <option *ngFor="let item of pService.pageItemsArray" [ngValue]="item.values" translate>{{item.label}}
      </option>
    </select>
  </div>
  <div class="d-flex justify-content-between p-2 font17 fontbold" style="margin: auto 0;">
    <span class="font17 fontnormal" translate>lblTotal</span>:&nbsp;{{pService.total$ | async}}&nbsp;<span class="font17 fontnormal" translate>lblResults</span>
  </div>

</div>
        </div>

      </div>

    </div>
  </div>

</div>
<!-- new theme implementation ends -->
